import { wrapText } from '/src/utilities/formats';
import { FaCheckSquare, FaSquare } from 'react-icons/fa';
import { GoDot, GoDotFill } from "react-icons/go";

import { renderToString } from 'react-dom/server';
import { colors } from '/src/utilities/formats';

export const semAreasPlugin = {
    id: 'semAreas',
    beforeDraw(chart, args, options) {
        const { ctx, chartArea: { left, top, right, bottom }, scales: { x, y } } = chart;

        const x1 = x.getPixelForValue(options.x1);
        const x2 = x.getPixelForValue(options.x2);
        const y1 = y.getPixelForValue(options.y1);
        const y2 = y.getPixelForValue(options.y2);

        ctx.save();

        ctx.lineWidth = options.lineWidth ?? 2;
        ctx.strokeStyle = options.lineColor ?? '#000000';

        // x1 line
        ctx.beginPath();
        ctx.moveTo(x1, top);
        ctx.lineTo(x1, bottom);
        ctx.stroke();

        // // x2 line
        // ctx.beginPath();
        // ctx.moveTo(x2, top);
        // ctx.lineTo(x2, bottom);
        // ctx.stroke();

        // y1 line
        ctx.beginPath();
        ctx.moveTo(left, y1);
        ctx.lineTo(right, y1);
        ctx.stroke();

        // y2 line
        ctx.beginPath();
        ctx.moveTo(left, y2);
        ctx.lineTo(right, y2);
        ctx.stroke();

        // //y2 line
        // ctx.lineWidth = 2;
        // ctx.strokeStyle = colors.lightblue;
        // ctx.setLineDash([5, 10]);
        // ctx.beginPath();
        // ctx.moveTo(left, median);
        // ctx.lineTo(right, median);
        // ctx.stroke();

        // ctx.lineWidth = 2;
        // ctx.strokeStyle = colors.lightblue;
        // ctx.setLineDash([5, 10]);
        // ctx.beginPath();
        // ctx.moveTo(left, top25);
        // ctx.lineTo(right, top25);
        // ctx.stroke();

        if (options.shade) {
            ctx.fillStyle = '#4A86CA50';
            switch (options.shade) {
                case 1:
                    // top left
                    ctx.fillRect(left, top, x1 - left, y2 - top);
                    break;
                case 2:
                    // top right
                    ctx.fillRect(x1, top, right - x1, y2 - top);
                    break;
                case 3:
                    // center left
                    ctx.fillRect(left, y2, x1 - left, y1 - y2);
                    break;
                case 4:
                    // center right
                    ctx.fillRect(x1, y2, right - x1, y1 - y2);
                    break;
                case 5:
                    // bottom left
                    ctx.fillRect(left, y1, x1 - left, bottom - y1)
                    break;
                case 6:
                    // bottom center
                    ctx.fillRect(x1, y1, right - x1, bottom - y1)
                    break;
            }
        }

        if (options.showLabels) {
            // Quadrant Labels
            ctx.fillStyle = "#666666";
            wrapText(ctx, "Lower Access Higher Earnings", left + 10, top + 20)
            //wrapText(ctx, "Medium Pell\nHigh Earnings", x1 + 10, top + 20)
            wrapText(ctx, "Opportunity Colleges and Universities Higher Access Higher Earnings", right + -110, top + 20)
            //wrapText(ctx, "Low Pell Medium Earnings", left + 10, y2 + 20)
            wrapText(ctx, "Lower Access Medium Earnings", left + 10, y2 + 15)
            wrapText(ctx, "Higher Access Medium Earnings", right + -105, y2 + 15)
            wrapText(ctx, "Lower Access Lower Earnings", left + 10, bottom - 30)
            //wrapText(ctx, "High Pell\nMedium Earnings", right - 110, y2 + 20)
            wrapText(ctx, "Higher Access Lower Earnings", right - 110, bottom - 30)

            //ctx.fillStyle = "#195086";
            //wrapText(ctx, `Top 25% (${options.top25})`, right + 5, top25 + 5)
            //wrapText(ctx, `Median (${options.median})`, right + 5, median + 5)
            //ctx.fillStyle = "#000000";
        }
        ctx.restore();
    }
};

export const chartAreaBorderPlugin = {
    id: 'chartAreaBorder',
    beforeDraw(chart, args, options) {
        const { ctx, chartArea: { left, top, width, height } } = chart;
        ctx.save();
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.setLineDash(options.borderDash || []);
        ctx.lineDashOffset = options.borderDashOffset;
        ctx.strokeRect(left, top, width, height);
        ctx.restore();
    }
};


export const htmlLegendPlugin = {
    id: 'htmlLegend',
    afterUpdate(chart, args, options) {
        if (!options.containerID) return;

        const legendContainer = document.getElementById(options.containerID);

        let listContainer = legendContainer.querySelector('ul');
        if (!listContainer) {
            listContainer = document.createElement('ul');
            legendContainer.appendChild(listContainer);
        }
        while (listContainer.firstChild) {
            listContainer.firstChild.remove();
        }

        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        items.forEach(item => {
            const li = document.createElement('li');
            li.classList.add('legendItem');

            const boxSpan = document.createElement('span');
            boxSpan.classList.add('legendBox');
            boxSpan.style.color = item.hidden ? '#cccccc' : item.strokeStyle;
            boxSpan.innerHTML = item.hidden ? renderToString(<FaSquare className='faCheckbox' />) : renderToString(<FaCheckSquare className='faCheckbox' />);

            const textContainer = document.createElement('span');

            const text = document.createTextNode(item.text);
            textContainer.appendChild(text);
            li.appendChild(boxSpan);
            li.appendChild(textContainer);
            li.onclick = (e) => {
                chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                chart.update();
            };
            listContainer.appendChild(li);
        });
    }
};

export const textCenter = {
    id: 'textCenter',
    beforeDraw: (chart, args, options) => {
        const { ctx } = chart;
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        let x = chart.getDatasetMeta(0).data[0].x;
        let y = chart.getDatasetMeta(0).data[0].y;
        if (options.centerNumber) {
            y -= 30;
            ctx.font = 'bold 40px Oswald, sans-serif';
            ctx.fillStyle = '#0d2f4f';
            ctx.fillText(options.centerNumber, x, y);
        }
        if (options.centerText) {
            ctx.font = '600 16px "Open Sans", sans-serif';
            ctx.fillStyle = '#000';
            let lines = options.centerText.split(/\\n|\//);
            y -= (lines.length == 1 && !options.centerNumber ? 0 : 20);
            if (options.centerNumber) {
                y += 55;
            }
            for (let i = 0; i < lines.length; i++) {
                if (i > 0) y += 20;
                ctx.fillStyle = colors[lines[i]];
                ctx.fillText(lines[i], x, y);
            }
        }
    }
};


export const doughnutLegendPlugin = {
    id: 'doughnutLegend',
    afterUpdate(chart, args, options) {
        if (!options.containerID) return;

        const legendContainer = document.getElementById(options.containerID);

        let listContainer = legendContainer.querySelector('ul');
        if (!listContainer) {
            listContainer = document.createElement('ul');
            legendContainer.appendChild(listContainer);
        }
        while (listContainer.firstChild) {
            listContainer.firstChild.remove();
        }

        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        items.forEach(item => {
            const li = document.createElement('li');
            li.classList.add('legendItem');

            const boxSpan = document.createElement('span');
            boxSpan.classList.add('legendBox');
            boxSpan.style.color = item.hidden ? '#cccccc' : item.fillStyle;
            boxSpan.innerHTML = item.hidden ? renderToString(<GoDot />) : renderToString(<GoDotFill />);

            const textContainer = document.createElement('span');
            textContainer.classList.add('legendText');
            const text = document.createTextNode(item.text);
            textContainer.appendChild(text);

            let valueContainer = null;
            if (options.labelsToValues) {
                const value = options.labelsToValues[item.text];
                if (value) {
                    valueContainer = document.createElement('span');
                    valueContainer.classList.add('legendValue');
                    valueContainer.classList.add('ms-auto');
                    valueContainer.innerHTML = `${value}`;
                }
            }

            li.appendChild(boxSpan);
            li.appendChild(textContainer);
            if (valueContainer) {
                li.appendChild(valueContainer);
            }
            // li.onclick = (e) => {
            //     chart.toggleDataVisibility(item.index);
            //     chart.update();
            // };
            listContainer.appendChild(li);
        });
    }
};